import React, { useEffect, useState } from 'react';
import Alert from '../../../components/common/Alert';
import HeadingSection from '../../../components/common/Title/headingSection';
import PremioAPI from '../premio-api';
import ConvocatoriaCard from './ConvocatoriaCard';
import AddIcon from '@material-ui/icons/Add';
import '../../../assets/styles/content/convocatorias.scss';
import { useHistory } from 'react-router-dom';
import useSnackbar from '../../../hooks/useSnackbar';
import { getPremioDemoUrl } from '../premio-urls';

const ConvocatoriasList = () => {
  const history = useHistory();
  const { showSnackbar } = useSnackbar();
  const [convocatorias, setConvocatorias] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    const fetchConvocatorias = async () => {
      try {
        const response = await PremioAPI.fetchConvocatorias();
        if (!cancelled) setConvocatorias(response.data || []);
      } catch (fetchError) {
        const rawDetail =
          fetchError?.data?.detail ||
          fetchError?.data?.message ||
          fetchError?.statusText ||
          'No fue posible obtener las convocatorias.';
        const detail = Array.isArray(rawDetail) ? rawDetail.map(item => item.msg).join(' · ') : rawDetail;
        if (!cancelled) {
          setError(detail);
          showSnackbar(detail, 'error');
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    fetchConvocatorias();
    return () => { cancelled = true; };
  }, [showSnackbar]);

  const openDemo = () => {
    window.open(getPremioDemoUrl(), '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="user-container content-panel convocatorias__container">
      {error && <Alert type="error">{error}</Alert>}
      <HeadingSection
        title="Convocatorias Premio"
        subtitle="Consulta el estado y las fechas claves de cada convocatoria del programa Premio."
      />
      <div className="convocatorias__demo-actions">
        <button
          type="button"
          className="convocatorias__demo-button convocatorias__demo-button--primary"
          onClick={openDemo}
        >
          Iniciar demo
        </button>
        <button
          type="button"
          className="convocatorias__demo-button convocatorias__demo-button--with-icon"
          onClick={() => history.push('/premio/crear')}
        >
          <AddIcon fontSize="small" />
          Crear Premio
        </button>
      </div>
      <div className="convocatorias__list">
        {isLoading && <div className="convocatorias__empty">Cargando convocatorias...</div>}
        {!isLoading && convocatorias.length === 0 && (
          <div className="convocatorias__empty">Aún no hay convocatorias disponibles.</div>
        )}
        {!isLoading &&
          convocatorias.map((convocatoria) => (
            <ConvocatoriaCard
              key={convocatoria.id}
              convocatoria={convocatoria}
              onEdit={() => history.push(`/premio/${encodeURIComponent(convocatoria.id)}/editar`)}
              onViewApplications={() =>
                history.push(`/premio/${convocatoria.id}/postulaciones`, {
                  title: convocatoria.title,
                })
              }
            />
          ))}
      </div>
    </section>
  );
};

export default ConvocatoriasList;
